// SkeletonBundle.js
import React from "react";
import { Skeleton } from "antd";

const SkeletonBundle = ({ count = 10 }) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "2.5rem 0  1rem 0",
        }}
      >
        <Skeleton.Input active />
        <Skeleton.Input active />
      </div>
      <div style={{ gap: ".5rem", display: "flex" }}>
        {Array.from({ length: count }).map((_, index) => (
          <div key={index}>
            <Skeleton.Image
              style={{ width: "190px", height: "263px" }}
              active
            />
            <Skeleton.Input
              active
              style={{ width: "190px", height: "88px", marginTop: "8px" }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonBundle;
